import { atom, selector } from "recoil";
import { createDataRequest, updateDataRequest, getQuizListRequest } from "../../../api/controller/QuestionController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";

export const questionListState = atom({
    key: 'questionListState',
    default: [],
})
export const questionQuizState = atom({
	key: 'questionQuizState',
	default:{
		data:[],
		ovf:false,
	}
})

export const modalConfigDefault = { size: "lg", wizard: false }

export const filterQuestionQuizState = atom({
    key: 'filterQuestionQuizState',
    default: '',
})

export const questionFilterState = selector({
    key: 'questionFilterState',
    get: ({ get }) => (
        [
            {
                label: 'Quiz',
                size: 6,
                offset: 6,
                required: true,
                type: 'select',
                value: get(filterQuestionQuizState),
                list: get(questionQuizState),
            }
        ]
    ),
    set: ({ set }, e) => {
        if(e.filterLabel === 'Quiz'){
            set(filterQuestionQuizState, e)
        }
    }
})

export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: updateDataRequest } ],
    view: [ { name: 'Default View' } ],
}

export const questionDataStructureState = selector({
    key: 'questionDataStructureState',
    get: ({ get }) => (
        [

            { 
                label: 'Quiz',
                type: 'select',
                order: { form: 1 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
				list: get(questionQuizState),
				getRequest: getQuizListRequest,
            },
			{ 
                label: 'Name',
                type: 'text',
                order: { table: 2, form: 2 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Date',
                type: 'datepicker',
                order: { table: 2.1, form: 2.1 }, 
				table: { dateFormat: 'MMM Do, YYYY', postDateFormat:'YYYY-MM-DD' },
                create: [{ enabled: true, size: { xs: 12, md: 12 } , dateFormat: 'YYYY-MM-DD', options: { altInput: true, altFormat: 'F j, Y', dateFormat: 'Y-m-d' } }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Description',
                type: 'text',
                order: { table: 3, form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Image',
                type: 'file',
                order: { form: 4 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Correct Image',
                type: 'file',
                order: { form: 5 }, 
                create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Options',
                type: 'repeater',
                order: { form: 6 },
                create: [{ enabled: true, size: { xs: 12, md: 12 }, deleteBtnSize: 2, repeatLabel: true }], update: ['same_as:create.0'], view: ['same_as:create.0'],
                children: [
                    { 
                		label: 'Description',
                		type: 'text',
                		order: { form: 1 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            		},
					{ 
                		label: 'Image',
                		type: 'file',
                		order: { form: 2 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 9 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
            		},
					{ 
                		label: 'Is Correct',
                		type: 'switch',
                		order: { form: 3 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 3 }  }], update: ['same_as:create.0'], view: ['same_as:create.0'], 
						list: ['Yes', 'No'],
            		},
					
                ]
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
